import { Component, Input, OnInit } from "@angular/core";
import { QRCodeErrorCorrectionLevel } from "qrcode";
import { SharedModule } from "../../shared.module";
import { QRCodeModule } from "angularx-qrcode";

@Component({
  selector: "vl-qr-code",
  standalone: true,
  imports: [SharedModule, QRCodeModule],
  templateUrl: "./qr-code.component.html",
  styleUrls: ["./qr-code.component.scss"],
})
export class QrCodeComponent implements OnInit {
  @Input() data: string;
  @Input() width: number;
  @Input() margin: number;

  errorLevel = "M" as QRCodeErrorCorrectionLevel;

  constructor() {}

  ngOnInit(): void {}
}
